const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);
const FALSE_VALUES = new Set(['0', 'false', 'no', 'off']);

export function parseFeatureFlag(value, defaultValue = true) {
    if (value === undefined || value === null || String(value).trim() === '') {
        return defaultValue;
    }
    const normalized = String(value).trim().toLowerCase();
    if (TRUE_VALUES.has(normalized)) {
        return true;
    }
    if (FALSE_VALUES.has(normalized)) {
        return false;
    }
    return defaultValue;
}

export function isBillingUiEnabled() {
    return parseFeatureFlag(process.env.REACT_APP_BILLING_UI_ENABLED, true);
}

export function isAdminBillingUiEnabled() {
    return isBillingUiEnabled()
        && parseFeatureFlag(process.env.REACT_APP_ADMIN_BILLING_UI_ENABLED, true);
}
